<template>
  <div class="modal fade pl-0" id="pdf-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">

    <a :href="downloadLink" download="download" class="d-none" id="download-link"/>
    <div class="modal-dialog modal-dialog-centered" id="download-modal">
      <div class="modal-content">
        <div class="modal-body">
          <div class="col-md-12">
            <form @submit.prevent="downloadTasksPdf(selectedTasks)" method="post" id="downloadForm">
              <div class="row">
                <div class="col-md-12 text-center">
                  <h3 class="mb-2">Bericht erstellen</h3>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Überschrift 1</label>
                    <input class="form-control" v-model="headingOne">
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Überschrift 2</label>
                    <input class="form-control" v-model="headingTwo">
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-check">
                    <input type="checkbox" v-model="isChecked" class="form-check-input checkInput" id="exampleCheck1" :true-value="1" :false-value="0">
                    <label class="form-check-label mt-0 pl-1" for="exampleCheck1">
                      Anzeigedatum bei allen ausgewählten Mängeln auf das heutige Datum setzen.
                    </label>
                  </div>
                </div>
                <div class="col-md-12 text-right pt-3">
                  <button class="btn btn-secondary rounded" type="button" data-dismiss="modal"> Abbrechen </button>
                  <button class="btn btn-primary rounded ml-2" type="submit"> PDF erstellen </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
 import axios from 'axios'
 import moment from 'moment'
 export default {
   props: ['selectedTasks'],
   data() {
     return {
       headingOne: '',
       headingTwo: '',
       isChecked: 0,
       downloadLink: ''
     }
   },
   methods: {

     async downloadTasksPdf (selectedTasks , isDownload = true) {
       this.$store.commit('loading',true)
       $('#pdf-modal').modal('hide');
       let params = [this.$route.params.id , selectedTasks , this.headingOne , this.headingTwo , this.isChecked]
       selectedTasks.sort((a, b) => a - b);
       await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`, {
            methodName:  "getFlawPdfByIds",
            serviceName: "ProjectdocuService",
            parameters: params,
         },
         {
           headers: {
             apitoken: localStorage.apikey,
             deviceid: localStorage.deviceid,
             accept: 'application/json'
           }
         }).then(res => {
            this.$store.commit('loading',false)
            this.downloadPdf(res , isDownload);
        }).catch(error => {
          this.$toast.error('Oops .. ! Something Went Wrong.')
       });
     },

     async downloadPdf(res , isDownload){
      this.$store.commit('loading',true)
      let url = `${process.env.VUE_APP_BASE_URL}${res.data.objectType}&token=${localStorage.sessiontoken}`
      await fetch(url, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid
        }
      }).then(response => response.blob())
        .then(response => {
          let reader = new FileReader()
          reader.readAsDataURL(response)
          reader.onload = function () {
            let pdf = reader.result
            if (isDownload){
              let link = document.getElementById('download-link');
              link.href = pdf
              link.download = `${moment(new Date()).format('YYYY-MM-DD')}_Mangelbericht.pdf`
              link.click();
            }else {
              let html = `<iframe width='100%' height='100%' src='${pdf}'></iframe>`
              let newTab = window.open('Construction-Report-PDF?printerFriendly=true', '_blank')
              newTab.document.write(html)
            }
            document.getElementById('downloadForm').reset()
          }
        });
       this.$store.commit('loading',false);
     },

   }
 }
</script>
<style scoped>
#download-modal{
  width: 35rem;
}
input.checkInput{
  width: 15px;
  height: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/tasks/DownloadTasksPdfModal.vue